<template>
  <a-spin :spinning="confirmLoading">
    <a-card :body-style="{padding: '24px 32px'}" :bordered="false" title="基础信息">
      <a-form>
        <a-form-item>
          <span slot="label"> <b>标题</b></span>
          {{ this.headline }}纠偏
        </a-form-item>
        <a-form-item>
          <span slot="label"> <b>文字描述</b></span>
          <span v-html="this.content"></span>
        </a-form-item>
        <a-form-item
          v-if="fileList!=null"
        >
          <span slot="label"> <b>附件</b></span>
          <a-upload
            :fileList="fileList"
          >
          </a-upload>
        </a-form-item>
      </a-form>
    </a-card>
    <a-card :body-style="{padding: '24px 32px'}" :bordered="false" title="交流">
      <a-table
        ref="table"
        :dataSource="dataSource"
        :columns="columns"
        :rowKey="record => record.id"
      >
      </a-table>
    </a-card>
    <a-card :bordered="false">
      <a-form :form="form">
        <a-row :gutter="16">
          <a-col class="gutter-row" :span="25">
            <a-form-item
              label="发表评论"
            >
              <a-textarea
                maxlength="20"
                :rows="6"
                placeholder="请输入评论(小于20个字)"
                v-decorator="[
                  'comment',
                  {rules: [{ required: true, message: '请输入评论' }]}]"
              ></a-textarea>
            </a-form-item>
            <a-button
              @click="saveComment"
            >发表</a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-card>
    <footer-tool-bar>
      <a-button
        v-show="buttonShow"
        @click="solveError">解决</a-button>&nbsp;
      <a-button
        @click="handleCancel">取消</a-button>
    </footer-tool-bar>
  </a-spin>
</template>

<script>
import { getObj, addComment, solveError } from '@/api/correctError/correctError'
import FooterToolBar from '@/components/FooterToolbar/FooterToolBar'
import { mapState } from 'vuex'
export default {
  name: 'CorrectErrorDetails',
  components: {
    FooterToolBar
  },
  data () {
    return {
      confirmLoading: false,
      form: this.$form.createForm(this),
      dataSource: [],
      headline: '',
      content: '',
      correctErrorId: '',
      fileList: [],
      buttonShow: false,
      createUserId: '',
      solve: '',
      columns: [
        {
          title: '时间',
          dataIndex: 'createTime'
        },
        {
          title: '交流内容',
          dataIndex: 'content'
        },
        {
          title: '发信人',
          dataIndex: 'name'
        }
      ]
    }
  },
  activated () {
    this.correctErrorId = this.$route.query.id
    this.init(this.correctErrorId)
  },
  computed: {
    ...mapState({
      userId: (state) => state.user.userId
    }),
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    init (id) {
      this.confirmLoading = true
      getObj(id).then(res => {
        const record = res.data.data
        this.dataSource = record.sxCorrectErrorComments
        this.headline = record.sxCorrectError.headline
        this.content = record.sxCorrectError.content
        this.createUserId = record.sxCorrectError.createBy
        this.solve = record.sxCorrectError.solve
        if (this.createUserId === this.userInfo.userId && this.solve !== '1') {
          this.buttonShow = true
        }
        this.fileList = JSON.parse(record.sxCorrectError.file)
        this.confirmLoading = false
      })
    },
    handleCancel () {
      this.$router.push({ name: 'CorrectErrorView' })
    },
    solveError () {
      solveError(this.correctErrorId).then(res => {
        this.$router.push({ name: 'CorrectErrorView' })
      })
    },
    saveComment () {
      const { form: { resetFields } } = this
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          const sxCorrectErrorComment = {
            correctErrorId: this.correctErrorId,
            content: values.comment
          }
          addComment(sxCorrectErrorComment).then(res => {
            this.$message.success('发表成功', 1).then(() => {
              resetFields()
              this.init(this.correctErrorId)
            })
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
